import { render, staticRenderFns } from "./modal-pagination.vue?vue&type=template&id=72c0a902&scoped=true"
import script from "./modal-pagination.vue?vue&type=script&lang=js"
export * from "./modal-pagination.vue?vue&type=script&lang=js"
import style0 from "./modal-pagination.vue?vue&type=style&index=0&id=72c0a902&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0a902",
  null
  
)

export default component.exports